
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/termsOfUse",
      function () {
        return require("private-next-pages/termsOfUse.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/termsOfUse"])
      });
    }
  